///<reference path="../../../helper/DateHelper.ts"/>
namespace SPA
{
	export namespace Realtor
	{
		import AJAXMethod = Wollmilch.AJAXMethod;
		import DateHelper = Helper.DateHelper;

		export interface IDocument {
			id: number;
			filename: string;
			title: string;
			is_custom?: boolean;
			group_id: number;
			default_title: string;
			default_id: number;
			shop_item: SPA.Shop.IShopItems | null;
			created_at: string|null;
			order_at: string|null;
			deliver_at: string|null;
		}

		export class DocumentBox
		{
			private Title: string;
			private ObjectNumber: string;
			private RealtorObject: RealtorObjectModel;
			private Placeholder: string = 'assets/images/placeholder-image.png';
			private Document: IDocument;
			private MultiUpload: boolean;
			private BoxForm: HTMLFormElement;
			private FileInput: HTMLInputElement;
			private shopItem: string;

			private docMikroID:number;
			private docMakroID:number;
			private docBesichtigungID:number;

			public constructor(object: RealtorObjectModel, file: IDocument)
			{
				this.docMikroID = Number( app.getConfigValue("DocMikrolageID") );
				this.docMakroID = Number(app.getConfigValue("DocMakrolageID") );
				this.docBesichtigungID = Number(app.getConfigValue("DocBesichtigungID") );

				this.Title = file.title || file.default_title || '???';
				this.ObjectNumber = object.ObjectNumber;
				this.RealtorObject = object;
				this.Document = file;
				this.MultiUpload = file.is_custom ? true : false;

				this.shopItem = this.Document.shop_item as string;

				this.BoxForm = document.createElement('form');
				this.BoxForm.enctype = 'multipart/form-data';
				this.BoxForm.method = 'post';

				if (this.MultiUpload) {
					$(this.BoxForm).addClass('wildcard');
				}

				this.FileInput = document.createElement('input');
				if (this.Document.group_id === 4) {
					this.FileInput.accept = 'image/jpeg,image/x-png';
				}
				this.FileInput.type = 'file';
				this.FileInput.name = 'files[]';

				$(this.BoxForm).addClass('doc-card').on('submit', (e: Event) => this.onFormSubmit(e));
				console.log(this.Document);
			}

			public setMultiUpload(state: boolean)
			{
				this.MultiUpload = state;
			}

			public Build(): JQuery<Element>
			{
				const Box: JQuery<Element> = $(this.BoxForm)
					.empty()  // Important when replacing content
					.append(this.BuildHeadline())
					.append(this.BuildActionBar())
					.append(this.BuildPreviewArea())
					.append(this.BuildFooterArea());

				return Box;
			}

			public BuildActionBar(): JQuery
			{

				const actionbar = ui.$$.div().addClass('doc-actionplane');

				// Create a Button after 5 minutes to generate the Map if they was not generated automatically
				if ((this.Document.default_id === this.docMikroID || this.Document.default_id === this.docMakroID) && this.Document.id === 0){

					// Check the creation Date
					const dateCreated = new Date(this.RealtorObject.CreatedAt.date);
					const dateNow = new Date();

					// Check 5 minutes later
					if ((dateCreated.getTime() + (1000*60*5)) < dateNow.getTime() ){

						const retryDiv = ui.$$.div().addClass("text-right");

						const retryBtn = ui.$$.button()
							.addClass('btn btn-primary mikromakro-refresh').attr({type: 'button', title: 'Erneut erstellen'})
							.append($('<i class="fa fa-sync-alt"></i>'));

						const infoTxt = $("<span class='mikromakro-info text-danger'>API Fehler beim Erstellen...</span>");

						retryDiv.append([infoTxt, retryBtn]);

						const requestData = {
							ObjectNumber: this.ObjectNumber,
							Address: this.RealtorObject.Address
						};

						retryBtn.on('click', () => {
							const idPrefix = 'object-' + (this.RealtorObject.Object ? this.RealtorObject.Object.ID : 0);

							$('#' + idPrefix + '-exposedocs .btn.mikromakro-refresh').addClass('disabled').prop('disabled', true);
							$('#' + idPrefix + '-exposedocs span.mikromakro-info').removeClass('text-danger').addClass('text-success').text("Karte wird erstellt... ");
							new Wollmilch.AJAX({
								method: 'POST',
								url: 'object/mikromakro',
								data: JSON.stringify(requestData)
							}, Wollmilch.AJAXCallbase_e.REALTOR).send();

						});
						retryDiv.appendTo(actionbar);

					}
				}
				// Documents that can be ordered
				if (this.shopItem && this.Document.order_at === null)
				{
					if (!this.Document.id && this.Document.created_at === null && this.Document.default_id !== this.docBesichtigungID) {
						const orderBtn = ui.$$.button()
							.addClass('btn btn-primary action-order').attr({type: 'button', title: 'Bestellen'})
							.append($('<i class="fa fa-shopping-cart"></i>'));
						orderBtn.on('click', () => {
							const order = new SPA.Shop.Page(this.Document, this.RealtorObject);
							// Looks weired but preserves closure to current class (Fat arrow)
							order.setCallback((document: IDocument) => this.onOrderSend(document));
						})
						.appendTo(actionbar);
					}
				}

				// Sonderfall (11 Grundbuch, 12 Baulasten) - Vollmacht herunterladen
				if (this.shopItem === "DEED" || this.shopItem === "ER") {
					const btnAuthority = ui.$$.button()
						.addClass('btn btn-primary action-order').attr({
							type: 'button',
							title: 'Vollmacht herunterladen'
						})
						.append($('<i class="fas fa-file"></i>'));
					btnAuthority.on('click', () => {
						let filepath: string = '';
						const link = document.createElement("a");
						if (this.shopItem === "DEED") {
							filepath = app.getRemotePath() + 'Vollmacht_Grundbuch.pdf';
							link.download = 'Vollmacht Grundbuch.pdf';
						} else if (this.shopItem === "ER") {
							filepath = app.getRemotePath() + 'Vollmacht_Baulastenverzeichnis.pdf';
							link.download = 'Vollmacht Baulastenverzeichnis.pdf';
						}

						link.href = filepath;
						/* Chapter2 - stores document with description as document.name */
						link.setAttribute('target', '_blank');
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					});
					actionbar.append(btnAuthority);
				}

				if (!this.Document.order_at && (this.shopItem === 'DEED' || this.shopItem === 'ER')) {
					actionbar.append(ui.$$.div().addClass('vspacer'));
				}

				if (this.Document.id && this.Document.filename)
				{
					const btnPreview = ui.$$.button()
						.addClass('btn btn-primary action-preview').attr({type: 'button', title: 'Öffnen'})
						.append($('<i class="fas fa-tv"></i>'));

					btnPreview.on('click', () =>
					{
						let params = '';
						let filename = '';
						if (this.Document.filename.indexOf('{') === 0) {
							filename = JSON.parse(this.Document.filename).remote;
						} else {
							filename = this.Document.filename;
						}
						let tagname = 'img';

						if (this.Document.filename.indexOf('.pdf') !== -1) {
							tagname = 'iframe';
							params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
						}
						// Using the default_id as storage folder
						// @todo take document_id into account
						let previewSrc = filename;
						if (previewSrc.indexOf('http') !== 0)
						{
							previewSrc = app.getRemotePath() + previewSrc;
						}
						const element = document.createElement(tagname);
						element.src = previewSrc + params;

						new ui.dialog.Modal({
							size: 'quick7',
							noCloseBtn: false,
							body: [
								$(element)
							]
						}).Show();
					});
					// ! Forward Button TODO: implement email function
					// const btnForward = ui.$$.button()
					// 	.addClass('btn btn-primary action-send').attr({type: 'button', title: 'Weiterleiten'})
					// 	.append($('<i class="fas fa-envelope"></i>'))
					// 	.on('click', () => this.onDocumentForward());
					const btnDownload = ui.$$.button()
						.addClass('btn btn-default action-download').attr({type: 'button', title: 'Download'})
						.append($('<i class="fas fa-download"></i>'))
						.on('click', () => this.onDocumentDownload());

					actionbar
						.append(btnPreview)
						// ! .append(btnForward)
						.append(btnDownload)
						.append(ui.$$.div().addClass('vspacer'));
				}

				if (!this.Document.deliver_at && !this.Document.order_at && this.Document.default_id !== this.docMakroID && this.Document.default_id !== this.docMikroID)
				{
					if (!this.Document.id && this.Document.created_at === null) {
						ui.$$.button()
							.on('click', () => {
								$(this.FileInput).trigger('click');
							})
							.addClass('btn btn-default action-upload').attr({type: 'button', title: 'Upload'})
							.append($('<i class="fas fa-upload"></i>'))
							.appendTo(actionbar);
					} else if (this.Document.id && this.Document.order_at === null && this.shopItem) {
						ui.$$.button()
							.on('click', () => {
								$(this.FileInput).trigger('click');
							})
							.addClass('btn btn-default action-upload').attr({type: 'button', title: 'Upload'})
							.append($('<i class="fas fa-upload"></i>'))
							.appendTo(actionbar);
					}
				}

				if (this.Document.id && this.Document.filename && this.Document.default_id !== this.docMakroID && this.Document.default_id !== this.docMikroID && !this.Document.deliver_at)
				{
					const btnDelete = ui.$$.button()
						.on('click', () => this.onDeleteAction())
						.addClass('btn btn-danger action-delete').attr({type: 'button', title: 'Anlage löschen'})
						.append($('<i class="fas fa-trash"></i>'));
					actionbar.append(btnDelete);
				}

				return actionbar;
			}

			private BuildHeadline(): JQuery
			{
				const title: string = this.Document.default_id === 0 ? this.Document.title : this.Document.default_title;
				const headline = ui.$$.h(3,
					[$('<span>' + title + '</span>')]
				);

				if (!this.Document.default_id)
				{
					// Enable title editing for custom uploads
					headline.on('click', () => {
						if (headline.data('editing') === true)
						{
							return;
						}
						headline.data('editing', true);

						// Hide current title
						headline.find('span').hide();

						// Add an input element
						const titleInput = ui.$$.input()
							.addClass('form-control')
							.val(this.Document.title || '');

						// Create and show a save button
						const titleSaveBtn = ui.$$.button().addClass('btn btn-primary').html('<i class="fas fa-save" title="Speichern"></i>')
							.on('click',  (e) => {
								e.preventDefault();

								new Wollmilch.AJAX({
									url: 'document/update/' + btoa(this.ObjectNumber),
									method: 'POST',
									data: {
										id: this.Document.id,
										// @ts-ignore Data property exists!
										title: titleInput.val()
									},
									contentType: "application/json",
									on: {
										success: (text) => {
											const response: Wollmilch.ResponseObject = JSON.parse(text);

											if (!response.success) {
												alert('Fehler beim Aktualisieren der Anlage');
												return;
											}

											this.Document = response.data;
											this.Build();
										}
									}
								}, AJAXCallbase_e.REALTOR).send();
							});

						headline
							.append(titleInput)
							.append(titleSaveBtn);
					});
				}

				return headline;
			}

			private BuildPreviewArea(): JQuery
			{
				const previewArea = ui.$$.div().addClass('doc-preview');

				if (this.Document.id && this.Document.filename && this.Document.filename.indexOf('.pdf') === -1)
				{
					const btnShowForPrint = $('<button type="button" title="Print-Exposé"><i class="fas fa-file-alt"></i></button>');
					const btnShowOnline = $('<button type="button" title="Online-Exposé"><i class="fas fa-globe"></i></button>');

					$(btnShowForPrint).on('click', (e: Event) => {
						$(e.currentTarget as EventTarget).toggleClass('enabled');
					});
					$(btnShowOnline).on('click', (e: Event) => {
						$(e.currentTarget as EventTarget).toggleClass('enabled');
					});

					previewArea.append(btnShowForPrint).append(btnShowOnline);
				} else if (this.Document.order_at)
				{
					const orderDateText = ui.$$.div().addClass('doc-preview-order-at')
						.append(
							`<div>
								<span>Dokument bestellt am</span>
								<span class="order-date">${DateHelper.getDateTimeFromTstamp(this.Document.order_at as string)} Uhr</span>
							</div>`);
					previewArea.append(orderDateText);

					// Set class if Document was delivered
					if (this.Document.deliver_at) {
						orderDateText.addClass("delivered");
					}
				} else if (this.Document.id && !this.Document.filename && !this.Document.order_at) {
					// Case if price get requested
					const requestDateText = ui.$$.div().addClass('doc-preview-order-at')
						.append(
							`<div>
								<span>Preis angefragt am</span>
								<span class="order-date">${DateHelper.getDateTimeFromTstamp(this.Document.created_at as string)} Uhr</span>
							</div>`);
					previewArea.append(requestDateText);

					// Set class if Document was delivered
					if (this.Document.deliver_at) {
						requestDateText.addClass("delivered");
					}
				}

				let previewType = ui.$$.img().addClass('doc-placeholder');
				let previewSrc = this.Placeholder;
				let previewAttr = 'src';

				// Ordered documents have an id but no filename
				if (this.Document.id && this.Document.filename)
				{
					let params = '';
					let filename = '';

					// Todo Remove this in future, early draft backwards compatibility
					if (this.Document.filename.indexOf('{') === 0)
					{
						filename = JSON.parse(this.Document.filename).remote;
					} else {
						filename = this.Document.filename;
					}

					if (filename.indexOf('.pdf') !== -1)
					{
						previewType = ui.$$.iframe();
						// previewType = $('<embed>');
						previewAttr = 'src';
						params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
					}

					previewSrc = filename;
					if (filename.indexOf('http') !== 0)
					{
						previewSrc = app.getRemotePath() + filename;
					}
					previewSrc += params;
				}

				previewType
					.attr(previewAttr, previewSrc)
					.appendTo(previewArea);

				// Add status marker to default documents only
				if (this.Document.default_id)
				{
					const status = ui.$$.div().addClass('status');
					if (this.Document.id && this.Document.filename)
					{
						status.addClass('status-ok');
						status.append('<i class="fas fa-check">');
					}
					else if (this.Document.id && this.Document.order_at && !this.Document.filename)
					{
						status.append('<i class="fas fa-shopping-cart" style="font-size:0.9em;color: #4d5867;">');
					} else if (this.Document.id && !this.Document.filename && !this.Document.order_at) {
						status.append('<i class="fas fa-file-invoice-dollar" style="font-size:0.9em;color: #4d5867;">');
					} else {
						status.addClass('status-fail');
						status.append('<i class="fas fa-times">');
					}
					status.appendTo(previewArea);
				}

				// Add custom upload event
				$(this.FileInput).on('change', (e: Event) => {
					this.onDragDrop(previewArea);
				});
				// previewArea.on('drop', (e: JQuery.Event) => {
				// 	e.preventDefault();

				// 	this.FileInput.files = e.originalEvent.dataTransfer.files;
				// 	this.onDragDrop(previewArea);
				// });
				// Add drag & drop events
				previewArea.on('dragover drop', (e: JQuery.Event) => {
					e.preventDefault();
					if (e.type === 'dragover') {
						// We have to capture dragover and drop for d&d to work
						return;
					}
					this.FileInput.files = e.originalEvent.dataTransfer.files;
					this.onDragDrop(previewArea);
				})
				.on('click', (e) => {
					if (e.target.tagName.toLowerCase() === 'img') {
						let tagname = 'img';
						let params = '';

						if (!this.Document.filename) { return; }

						if (this.Document.filename.indexOf('.pdf') !== -1) {
							tagname = 'iframe';
							params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
						}

						const element = document.createElement(tagname);
						// Using the default_id as storage folder
						// @todo take document_id into account
						element.src = this.Document.filename + params;

						new ui.dialog.Modal({
							size: 'quick7',
							noCloseBtn: false,
							body: [
								$(element)
							]
						}).Show();
					}
				});

				return previewArea;
			}

			private BuildFooterArea(): JQuery
			{
				$(this.FileInput).hide();
				let defaultDocText = '---';
				if ( this.Document.default_id === 11 || this.Document.default_id === 29) {
					defaultDocText = 'Karte wird erstellt';
				}

				const lasModified: string = this.Document.created_at ? DateHelper.getDateTimeFromTstamp(this.Document.created_at as string): "---";

				const status = ui.$$.div().addClass('doc-status-list clear')
					.append(ui.$$.span().addClass('doc-status-desc').text('Status:'))
					.append(ui.$$.span().addClass('doc-status-date').text(
						this.Document.id ? ' erstellt am ' + lasModified + ' Uhr' : defaultDocText)
					)
					.append(this.FileInput);

				return status;
			}

			private onDragDrop(previewArea: JQuery) {
				let uploadAccepeted: boolean = true;
				const fileType: string = this.FileInput.files[0].type;

				// @Todo set accepted fileTypes for groups/files in the database
				// Show file name or upload count as preview prior to upload
				if (this.Document.deliver_at || (this.Document.group_id === 4 && !(fileType === "image/jpeg" || fileType === "image/png"))) {
					uploadAccepeted = false;
				}
				if (uploadAccepeted) {
					previewArea.find('.name-preview').remove();
					previewArea.find('.doc-placeholder').hide();
					if (this.FileInput.files.length === 1 || this.MultiUpload === false) {
						previewArea.prepend('<div class="name-preview">' + this.FileInput.files[0].name + '</div>');
					} else {
						previewArea.prepend('<div class="name-preview">' + this.FileInput.files.length + ' Dateien</div>');
					}

					$(this.BoxForm).trigger('submit');
				} else {
					alert('Leider können nur JPEG und PNG Dateien hochgeladen werden.');
				}
			}

			private onFormSubmit(e: Event)
			{
				e.preventDefault();
				const formData = new FormData();
				for (const file of this.FileInput.files)
				{
					formData.append('files[]', file);
					if (!this.MultiUpload)
					{
						break;
					}
				}

				formData.append('id', this.Document.id.toString());
				formData.append('default_id', this.Document.default_id.toString());
				formData.append('group_id', this.Document.group_id.toString());
				formData.append('object_number', this.ObjectNumber);

				let url = '';
				let callbase = AJAXCallbase_e.REALTOR;
				const method:  AJAXMethod = 'POST';
				if (this.Document.id) {
					url = 'artifact/replace/' + this.Document.id;
					callbase = AJAXCallbase_e.APIV1;
					// method = 'PATCH';
				} else {
					url = 'object/upload/' + btoa(this.ObjectNumber);
				}

				new Wollmilch.AJAX({
					url,
					method,
					data: formData,
					contentType: false,
					on: {
						success: (text) => {
							const response = JSON.parse(text);

							// Force array structure
							if (!Array.isArray(response.data))
							{
								response.data = [response.data];
							}

							for (const file of response.data) {
								if (this.Document.default_id) {
									// Replace the current box with a new one
									this.Document = file;
									this.RealtorObject.docManager.setDefaultFile(this.Document.default_id, this.Document);
									this.Build();
								} else if (this.Document.id) {
									this.Document = file;
									this.Build();
								} else {
									// Add a new box for each uploaded item ...
									const newBox: DocumentBox = new DocumentBox(this.RealtorObject, file);
									// ... after the wildcard option
									$(this.BoxForm).after(newBox.Build());
								}
							}

							// Reset the multi upload form
							if (this.MultiUpload) {
								$(this.BoxForm).find('.name-preview').fadeOut();
								$(this.BoxForm).find('.doc-placeholder').fadeIn();
							}
						}
					}
				}, callbase).send();
			}

			private onDeleteAction()
			{
				// Request confirm for deletion
				const proceed = confirm('Möchten Sie dieses Dokument wirklich unwiderruflich löschen?');
				if (proceed === false) {
					return;
				}

				new Wollmilch.AJAX({
					url: 'document/delete/' + this.Document.id,
					method: 'DELETE',
					contentType: "application/json",
					on: {
						success: (text) => {
							const response: Wollmilch.ResponseObject = JSON.parse(text);
							if (!response.success) {
								alert('Fehler beim Löschen der Anlage');
								return;
							}
							if (this.Document.default_id === 0) {
								// Remove non-default attachments
								$(this.BoxForm).fadeOut(() => $(this.BoxForm).remove());
							} else {
								// Rebuild aka empty default attachment container
								// Reset Document Values
								this.resetDocument();
								$(this.BoxForm).replaceWith(this.Build());
							}
						}
					}
				}, AJAXCallbase_e.REALTOR).send();
			}

			private onDocumentDownload()
			{
				new Wollmilch.AJAX({
					url: 'artifact/download/' + this.Document.id,
					on: {
						success: (text) => {
							const response: Wollmilch.ResponseObject = JSON.parse(text);
							if (!response.success)
							{
								alert('Fehler beim Anfordern der Anlage');
								return;
							}

							const data = response.data;
							const blob = 'data:' + data.MimeType + ';' + (data.Base64 ? 'base64,' : '') + data.Blob;
							download(blob, (this.Document.title || this.Document.default_title) + '.' + data.Extension, data.MimeType);
						}
					}
				}, AJAXCallbase_e.APIV1).send();
			}

			private onDocumentForward(){
				const modal = $('body > .modal');

				modal.find('.modal-title').text((this.Document.title || this.Document.default_title) + ' per E-Mail versenden');
				modal.find('.modal-body').empty().append(this.buildForwardContent());
				modal.find('.btn-primary').html('<i class="fas fa-paper-plane"></i> <span>Dokument verschicken</span>');
				modal.modal('show');
			}

			private onOrderSend(data: IDocument): void
			{
				// Replace the current box with a new one
				this.Document = data;
				this.RealtorObject.docManager.setDefaultFile(this.Document.default_id, this.Document);
				this.Build();
			}

			private buildForwardContent(): JQuery
			{

				const inputForward = $('<input type="text" class="form-control" name="forward_mail" id="forward_mail" value="" placeholder="E-Mail Adresse">');
				const btnMailSelf = $('<button class="btn btn-info" style="width:100%">An mich selbst</button>').on('click', (e) => {
					inputForward.val('service@gsd-web.de');
				});
				const btnMailOther = $('<button class="btn btn-info" style="width:100%">Per Eingabe</button>').on('click', (e) => {
					inputForward.val('').focus();
				});
				const emailAutocomplete = $('<input type="text" name="address.search" placeholder="Kontakt E-Mail suchen" class="form-control">');
				const bidderAutocomplete = new SPA.Contacts.Autocomplete(emailAutocomplete, this.ObjectNumber, (contact: SPA.Contact) => {
					inputForward.val(contact.Email);
				});

				const html = ui.$$.div()
					.append('<p>An wen möchten Sie dieses Dokument versenden?</p>')
					.append($('<div style="display:grid;grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 20px;margin-bottom: 20px">')
						.append($('<div>')
							.append(btnMailSelf)
						)
						.append($('<div>')
							// .append('<div>An einen Kontakt</div>')
							.append(bidderAutocomplete.el())
							.append('<strong id="contact_forward_mail"></strong>')
						)
						.append($('<div>')
							.append(btnMailOther)
						)
					)
					.append($('<div>E-Mail Adresse</div>')
						.append(inputForward)
					)
					.append($('<div>Ihre Nachricht</div>')
						.append('<textarea class="form-control" rows="10"></textarea>')
					);

				return html;
			}

			private resetDocument() {
				this.Document.id = 0;
				this.Document.created_at = null;
				this.Document.deliver_at = null;
				this.Document.order_at = null;
				this.Document.filename = '';
				this.Document.title = '';
			}
		}
	}
}
